import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { FormFieldsContainer } from '../../../Form'
import { IS_VIEWING_BOOKING_AVAILABLE } from '../../RentalPortalViewing.constants'
import { VIEWING_FORM_FIELD_NAME } from '../RentalPortalViewingFormModal.constants'
import {
  getIsViewingFormBookMode,
  getIsViewingFormSlotSource,
} from '../RentalPortalViewingFormModal.utils'

import { useViewingFormSlotItems } from './RentalPortalViewingFormModalFields.hooks'
import { ViewingFormApplicantField } from './ViewingFormApplicantField'
import { ViewingFormDurationField } from './ViewingFormDurationField'
import { ViewingFormErrorNotification } from './ViewingFormErrorNotification'
import { ViewingFormListingField } from './ViewingFormListingField'
import { ViewingFormModeField } from './ViewingFormModeField'
import { ViewingFormRepeatFields } from './ViewingFormRepeatFields'
import { ViewingFormSlotPicker } from './ViewingFormSlotPicker'
import { ViewingFormStartField } from './ViewingFormStartField'
import { ViewingFormTimeSourceField } from './ViewingFormTimeSourceField'

function RentalPortalViewingFormModalFields({ slotsReloadRef }) {
  const { values } = useFormikContext()

  const listingId = values[VIEWING_FORM_FIELD_NAME.listing]?.value

  const isBookMode = getIsViewingFormBookMode(values)
  const isSlotSource = getIsViewingFormSlotSource(values)

  const {
    handleReload: handleReloadSlots,
    isLoading: isLoadingSlots,
    items: slotItems,
  } = useViewingFormSlotItems({ isSlotSource, listingId })

  const slotSelectStatesRef = useRef(null)

  function handleReloadAndOpenSlots() {
    handleReloadSlots()

    slotSelectStatesRef.current?.handleOpen()
  }

  useEffect(() => {
    slotsReloadRef.current = handleReloadAndOpenSlots
  })

  return (
    <FormFieldsContainer>
      <ViewingFormErrorNotification />
      {IS_VIEWING_BOOKING_AVAILABLE ? <ViewingFormModeField /> : null}
      <ViewingFormListingField />
      {isBookMode ? <ViewingFormApplicantField /> : null}
      {isBookMode ? <ViewingFormTimeSourceField /> : null}
      {isSlotSource ? (
        <ViewingFormSlotPicker
          isLoading={isLoadingSlots}
          items={slotItems}
          selectStatesRef={slotSelectStatesRef}
        />
      ) : (
        <ViewingFormStartField />
      )}
      {isSlotSource ? null : <ViewingFormDurationField />}
      {isBookMode ? null : <ViewingFormRepeatFields />}
    </FormFieldsContainer>
  )
}

export default RentalPortalViewingFormModalFields
